
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns2c4b6a64c7926d0c26ce0a13c0532dfden from './en.yaml'
            i18n.addResourceBundle('en', '2c4b6a64c7926d0c26ce0a13c0532dfd', flattenObject(ns2c4b6a64c7926d0c26ce0a13c0532dfden), true, true);
        
        export default '2c4b6a64c7926d0c26ce0a13c0532dfd';
    